import React from 'react'
import {Link} from 'gatsby'

import logo from '../img/logo.svg'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faTwitter} from '@fortawesome/free-brands-svg-icons/faTwitter';
import {faGithub} from '@fortawesome/free-brands-svg-icons/faGithub';

const Footer = class extends React.Component {
  render() {
    return (
      <footer className="footer has-text-white-ter section">
        <div className="content has-text-white-ter">
          <div className="container has-text-white-ter">
            <div className="columns">
              <div className="column is-3">
                <section className="menu">
                  <h5>Project</h5>

                  <ul className="menu-list">
                    <li>
                      <Link to="/" className="navbar-item">
                        Home
                      </Link>
                    </li>
                    <li>
                      <Link to="/self-hosted" className="navbar-item">
                        Self Hosted
                      </Link>
                    </li>
                    <li>
                      <Link to="/standalone" className="navbar-item">
                        Standalone
                      </Link>
                    </li>
                  </ul>
                  <div className="social">
                    <a title="twitter" href="https://twitter.com/AlexTselegidis" target="_blank" rel="noopener noreferrer">
                      <FontAwesomeIcon icon={faTwitter} size="lg"/>
                    </a>

                    <a title="github" href="https://github.com/alextselegidis/plainpad" target="_blank" rel="noopener noreferrer">
                      <FontAwesomeIcon icon={faGithub} size="lg"/>
                    </a>
                  </div>
                </section>
              </div>
              <div className="column is-3">
                <h5>
                  Open Source
                </h5>
                <section className="menu">
                  <ul className="menu-list">
                    <li>
                      <Link className="navbar-item" to="/get-involved">
                        Get Involved
                      </Link>
                    </li>
                    <li>
                      <a className="navbar-item" href="https://github.com/alextselegidis/plainpad" target="_blank" rel="noopener noreferrer">
                        Repository
                      </a>
                    </li>
                    <li>
                      <a className="navbar-item" href="https://github.com/alextselegidis/plainpad/issues" target="_blank" rel="noopener noreferrer">
                        Issue Tracker
                      </a>
                    </li>
                  </ul>
                </section>
              </div>
              <div className="column is-3">
                <h5>
                  Enterprise
                </h5>
                <section className="menu">
                  <ul className="menu-list">
                    <li>
                      <Link className="navbar-item" to="/customize">
                        Customize
                      </Link>
                    </li>
                    <li>
                      <Link className="navbar-item" to="/support">
                        Support
                      </Link>
                    </li>
                    <li>
                      <Link className="navbar-item" to="/partners">
                        Partners
                      </Link>
                    </li>
                    <li>
                      <Link className="navbar-item" to="/white-label">
                        White Label
                      </Link>
                    </li>
                  </ul>
                </section>
              </div>
              <div className="column is-3">
                <h5>
                  Resources
                </h5>
                <section className="menu">
                  <ul className="menu-list">
                    <li>
                      <a className="navbar-item" href="https://github.com/alextselegidis/plainpad/releases" target="_blank" rel="noopener noreferrer">
                        Downloads
                      </a>
                    </li>
                    <li>
                      <a className="navbar-item" href="https://github.com/alextselegidis/plainpad/tree/master/docs" target="_blank" rel="noopener noreferrer">
                        Docs
                      </a>
                    </li>
                    <li>
                      <a href="https://alextselegidis.com/try/plainpad" className="navbar-item" target="_blank" rel="noopener noreferrer">
                        Demo
                      </a>
                    </li>
                  </ul>
                </section>
              </div>
            </div>

            <div className="columns is-mobile footer-bottom">
              <div className="column">
                <img
                  src={logo}
                  alt="Plainpad"
                  className="footer-logo"
                />

                <h6 className="footer-title">
                  Plainpad &copy; {(new Date()).getFullYear()}
                </h6>
              </div>

              <div className="column has-text-right footer-bottom-links">
                <Link to="/terms">
                  Terms
                </Link>

                <Link to="/privacy">
                  Privacy
                </Link>
              </div>
            </div>
          </div>
        </div>
      </footer>
    )
  }
}

export default Footer
